// import {
//   Box,
//   Grid,
//   IconButton,
//   MenuItem,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Typography,
// } from "@mui/material";
// import React, { useRef, useState } from "react";
// import Input from "../../../../components/Input";
// import ButtonComp from "../../../../components/Button";
// import trash from "../../../../assets/images/trash.svg";
// import eye from "../../../../assets/images/eye.svg";
// import { useUserStore } from "../../../../store/useUserStore";
// import { useCaseCreationStore } from "../../../../store/useCaseCreationStore";
// import { caseSubmit } from "../../../../services/case-services";
// import { useToast } from "../../../../hooks/useToast";
// import { useOtpVerifiedStore } from "../../../../store/useOtpVerifiedStore";

// interface DocumentRow {
//   id: number;
//   documentName: string;
//   documentType: string;
//   uploadedBy: string;
//   date: string;
//   file: File;
// }

// export default function CaseDocuments({ onBack, onNext }: any) {
//   const [rows, setRows] = useState<DocumentRow[]>([]);
//   const [selectedFile, setSelectedFile] = useState<File | null>(null);
//   const [documentType, setDocumentType] = useState("");
//   const fileInputRef = useRef<HTMLInputElement | null>(null);

//   const role = useUserStore((s) => s.role);
//   const { setIsOtpVerified } = useOtpVerifiedStore();

//   const { showInfoToast } = useToast();

//   const {
//     informantDetails,
//     deceasedDetails,
//     deceasedLocation,
//     documents,
//     setDocuments,
//     resetCase,
//   } = useCaseCreationStore();

//   const handleAdd = () => {
//     if (!selectedFile || !documentType) return;

//     const newRow: DocumentRow = {
//       id: Date.now(),
//       documentName: selectedFile.name,
//       documentType,
//       uploadedBy: role,
//       date: new Date().toLocaleDateString("en-GB", {
//         day: "2-digit",
//         month: "short",
//         year: "numeric",
//       }),
//       file: selectedFile,
//     };

//     setRows((prev) => [...prev, newRow]);

//     // ✅ Store in Zustand using API key name
//     setDocuments({
//       [documentType]: selectedFile,
//     });

//     setSelectedFile(null);
//     setDocumentType("");
//     if (fileInputRef.current) fileInputRef.current.value = "";
//   };

//   const handleDelete = (id: number) => {
//     setRows((prev) => prev.filter((row) => row.id !== id));
//   };

//   const handlePreview = (file: File) => {
//     const fileURL = URL.createObjectURL(file);
//     window.open(fileURL);
//   };

//   const handleSubmit = async () => {
//     const formData = new FormData();

//     const casePayload = {
//       claimant: informantDetails,
//       deceased: deceasedDetails,
//       deceasedLocation: deceasedLocation,
//     };

//     formData.append("case", JSON.stringify(casePayload));

//     Object.entries(documents).forEach(([key, file]) => {
//       if (file) {
//         formData.append(key, file as File);
//       }
//     });

//     try {
//       const response = await caseSubmit(formData);
//       if (response.status === 200) {
//         setIsOtpVerified(false)
//         onNext();
//         resetCase();
//       } else {
//         showInfoToast(response.data.message);
//       }
//     } catch (error) {
//       console.error("Error creating case:", error);
//     }
//   };

//   return (
//     <Paper
//       elevation={0}
//       sx={{
//         p: 4,
//         mt: 3,
//         borderRadius: 3,
//         backgroundColor: "#fff",
//       }}
//     >
//       {/* Top Form Section */}
//       <Grid container spacing={3} alignItems="center">
//          {/* Document Type */}
//         <Grid size={{ xs: 12, md: 5 }}>
//           <Typography
//             sx={{ mb: 1, fontSize: 18, fontWeight: 600, textAlign: "left" }}
//           >
//             Document Type
//           </Typography>

//           <Input
//             select
//             fullWidth
//             value={documentType}
//             onChange={(e: any) => setDocumentType(e.target.value)}
//           >
//             <MenuItem value="">Select Document Type</MenuItem>
//             <MenuItem value="death_certificate">Death Certificate</MenuItem>
//             {/* <MenuItem value="ID Proof">ID Proof</MenuItem>
//             <MenuItem value="Address Proof">Address Proof</MenuItem> */}
//           </Input>
//         </Grid>
        
//         {/* File Upload */}
//         <Grid size={{ xs: 12, md: 5 }}>
//           <Typography
//             sx={{ mb: 1, fontSize: 18, fontWeight: 600, textAlign: "left" }}
//           >
//             Document
//           </Typography>

//           <Box
//             sx={{
//               border: "1px solid #E5E7EB",
//               borderRadius: "12px",
//               height: 56,
//               display: "flex",
//               alignItems: "center",
//               px: 2,
//             }}
//           >
//             <ButtonComp
//               variant="contained"
//               sx={{
//                 backgroundColor: "#6D6D6D",
//                 borderRadius: "12px",
//                 height: 36,
//                 minWidth: 100,
//                 mr: 2,
//               }}
//               onClick={() => fileInputRef.current?.click()}
//             >
//               Choose
//             </ButtonComp>

//             <Typography sx={{ color: "#6B7280" }}>
//               {selectedFile ? selectedFile.name : ""}
//             </Typography>

//             <input
//               type="file"
//               hidden
//               ref={fileInputRef}
//               onChange={(e) =>
//                 setSelectedFile(e.target.files ? e.target.files[0] : null)
//               }
//             />
//           </Box>
//         </Grid>

//         {/* ADD Button */}
//         <Grid size={{ xs: 12, md: 2 }}>
//           <Box mt={{ xs: 2, md: 4 }}>
//             <ButtonComp
//               variant="contained"
//               onClick={handleAdd}
//               sx={{
//                 backgroundColor: "#EF6C00",
//                 borderRadius: "30px",
//                 height: 56,
//                 width: "100%",
//                 fontWeight: 600,
//                 fontSize: 16,
//                 "&:hover": {
//                   backgroundColor: "#E65100",
//                 },
//               }}
//             >
//               ADD
//             </ButtonComp>
//           </Box>
//         </Grid>
//       </Grid>

//       {/* Table Section */}
//       <TableContainer
//         component={Paper}
//         elevation={0}
//         sx={{
//           mt: 4,
//           border: "1px solid #E5E7EB",
//         }}
//       >
//         <Table>
//           <TableHead sx={{ backgroundColor: "#F3F4F6" }}>
//             <TableRow>
//               <TableCell sx={{ fontWeight: 700 }}>Document Name</TableCell>
//               <TableCell sx={{ fontWeight: 700 }}>Document Type</TableCell>
//               <TableCell sx={{ fontWeight: 700 }}>Uploaded By</TableCell>
//               <TableCell sx={{ fontWeight: 700 }}>Date</TableCell>
//               <TableCell sx={{ fontWeight: 700 }}>Action</TableCell>
//             </TableRow>
//           </TableHead>

//           <TableBody sx={{ backgroundColor: "#ffffff" }}>
//             {rows.length === 0 ? (
//               <TableRow>
//                 <TableCell colSpan={5} align="center">
//                   No documents added yet
//                 </TableCell>
//               </TableRow>
//             ) : (
//               rows.map((row) => (
//                 <TableRow key={row.id}>
//                   <TableCell>{row.documentName}</TableCell>
//                   <TableCell>{row.documentType}</TableCell>
//                   <TableCell>{row.uploadedBy}</TableCell>
//                   <TableCell>{row.date}</TableCell>
//                   <TableCell>
//                     <IconButton onClick={() => handlePreview(row.file)}>
//                       <img src={eye} alt="eye" width={20} />
//                     </IconButton>

//                     <IconButton onClick={() => handleDelete(row.id)}>
//                       <img src={trash} alt="trash" width={18} />
//                     </IconButton>
//                   </TableCell>
//                 </TableRow>
//               ))
//             )}
//           </TableBody>
//         </Table>
//       </TableContainer>

//       {/* Bottom Buttons */}
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           mt: 6,
//         }}
//       >
//         <ButtonComp variant="outlined" onClick={onBack} height={50} width={190}>
//           Back
//         </ButtonComp>

//         <ButtonComp
//           variant="contained"
//           onClick={handleSubmit}
//           height={50}
//           width={190}
//         >
//           SUBMIT
//         </ButtonComp>
//       </Box>
//     </Paper>
//   );
// }

import { useQuotationCreationStore } from "../../../../store/useQuotationCreationStore";
import DeceasedDetailsForm from "../../components/forms/DeceasedDetailsForm";
import Documents from "../../components/forms/Documents";


export default function CaseDocuments({ onNext, onBack, minimalCapture = false }: any) {


  return (
    <Documents
onBack={onBack}
      onNext={onNext}
      minimalCapture={minimalCapture}
    />
  );
}
